import React, { useState } from "react";
import Navbar from "../components/lib/Navbar";
import HeroSection from "../components/landing-page/agent/HeroSection";
import Driver from "../components/landing-page/agent/Driver";
import Owner from "../components/landing-page/agent/Owner";
import FAQ from "../components/lib/FAQ";
import Footer from "../components/lib/Footer";
import Loader from "../components/lib/Loader";

const Agent = () => {
  const [section, setSection] = useState<string>("driver");
  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <Navbar />
      </div>
      <div>
        <HeroSection />
      </div>
      <div>
        <div className="my-10">
          <h1 className="head-text">Get started easily</h1>
          <div className="flex items-center justify-between max-w-[250px] relative border rounded-full px-10 space-x-4 text-paragraph font-medium  duration-500 mx-auto">
            <div
              className={`cursor-pointer hover:text-primary hover:font-semibold py-2 text-lg ${
                section === "driver"
                  ? "font-semibold text-primary"
                  : "font-medium text-paragraph"
              }`}
              onClick={() => {
                setSection("driver");
              }}
            >
              <h1>Driver</h1>
            </div>
            <div
              className={`cursor-pointer hover:text-primary hover:font-semibold py-2 text-lg ${
                section === "owner"
                  ? "font-semibold text-primary"
                  : "font-medium text-paragraph"
              }`}
              onClick={() => {
                setSection("owner");
              }}
            >
              <h1>Owner</h1>
            </div>
          </div>
          {section === "driver" ? <Driver /> : <Owner />}
        </div>
      </div>

      <div className="my-24">
        <FAQ />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Agent;
